import { OptionDefinitionCompressedTypeEnum } from '@jooxter/api';
import { JxtHomeBookingOptionKindEnum, JxtHomeBookingOptions } from '@jooxter/ui';
import { isOptionChoiceValid } from './optionChoices';
import { IOptionChoicesField } from './types';

const OPTION_KIND: Record<OptionDefinitionCompressedTypeEnum, JxtHomeBookingOptionKindEnum> = {
  [OptionDefinitionCompressedTypeEnum.Checkbox]: JxtHomeBookingOptionKindEnum.Checkbox,
  [OptionDefinitionCompressedTypeEnum.Text]: JxtHomeBookingOptionKindEnum.Text,
  [OptionDefinitionCompressedTypeEnum.Textarea]: JxtHomeBookingOptionKindEnum.Textarea,
  [OptionDefinitionCompressedTypeEnum.List]: JxtHomeBookingOptionKindEnum.List,
};

/** Some of a space's options (its mandatory ones, its others, a move's): each on or off, with its value. */
export const OptionChoicesField = ({
  label,
  mandatoryLabel,
  choosePlaceholder,
  choices,
  showErrors,
  onChange,
}: IOptionChoicesField) => (
  <JxtHomeBookingOptions
    label={label}
    mandatoryLabel={mandatoryLabel}
    choosePlaceholder={choosePlaceholder}
    options={choices.map((choice) => ({
      id: choice.id,
      name: choice.name,
      kind: OPTION_KIND[choice.type],
      values: choice.possibleValues,
      mandatory: choice.mandatory,
      activated: choice.activated,
      value: choice.value,
      isInvalid: showErrors && !isOptionChoiceValid(choice),
    }))}
    onToggle={(id, activated) => onChange(id, { activated })}
    onValueChange={(id, value) => onChange(id, { value })}
  />
);
